import {
    FETCHING_MUNICIPALITIES_IN_PROGRESS,
    FETCHING_MUNICIPALITIES_COMPLETED,
    STORE_FETCHED_MUNICIPALITIES,
    SET_MUNICIPALITY_PAGE,
    FETCHING_MUNICIPALITY_IN_PROGRESS,
    STORE_FETCHED_MUNICIPALITY,
    FETCHING_MUNICIPALITY_COMPLETED,
    REMOVE_MUNICIPALITY,
    SET_MUNICIPALITY_FILTERS,
    STORE_ADDITIONAL_MUNICIPALITIES,
    CLEAR_MUNICIPALITY_REDUCER,
    FETCHING_ALL_MUNICIPALITIES_IN_PROGRESS,
    STORE_FETCHED_ALL_MUNICIPALITIES,
    FETCHING_ALL_MUNICIPALITIES_COMPLETED,
    EDITING_MUNICIPALITY_IN_PROGRESS,
    EDITING_MUNICIPALITY_COMPLETED,
    FETCHING_MUNICIPALITY_OPTIONS_IN_PROGRESS,
    STORE_MUNICIPALITY_OPTIONS,
    FETCHING_MUNICIPALITY_OPTIONS_COMPLETED,
    CREATING_MUNICIPALITY_IN_PROGRESS,
    CREATING_MUNICIPALITY_COMPLETED,
    DELETING_MUNICIPALITY_IN_PROGRESS,
    DELETING_MUNICIPALITY_COMPLETED,
    FETCHING_ADDITIONAL_MUNICIPALITIES_IN_PROGRESS,
    FETCHING_ADDITIONAL_MUNICIPALITIES_COMPLETED
} from '../constants';

export const ACTION_FETCHING_MUNICIPALITIES_IN_PROGRESS = () => { return { type: FETCHING_MUNICIPALITIES_IN_PROGRESS } };
export const ACTION_FETCHING_MUNICIPALITIES_COMPLETED = () => { return { type: FETCHING_MUNICIPALITIES_COMPLETED } };
export const ACTION_STORE_FETCHED_MUNICIPALITIES = (municipalities, totalMunicipalities) => { return { type: STORE_FETCHED_MUNICIPALITIES, payload: { municipalities: municipalities, totalMunicipalities: totalMunicipalities } } };

export const ACTION_FETCHING_ADDITIONAL_MUNICIPALITIES_IN_PROGRESS = () => { return { type: FETCHING_ADDITIONAL_MUNICIPALITIES_IN_PROGRESS } };
export const ACTION_FETCHING_ADDITIONAL_MUNICIPALITIES_COMPLETED = () => { return { type: FETCHING_ADDITIONAL_MUNICIPALITIES_COMPLETED } };
export const ACTION_STORE_ADDITIONAL_MUNICIPALITIES = (municipalities) => { return { type: STORE_ADDITIONAL_MUNICIPALITIES, payload: municipalities } };

export const ACTION_FETCHING_MUNICIPALITY_IN_PROGRESS = () => { return { type: FETCHING_MUNICIPALITY_IN_PROGRESS } };
export const ACTION_STORE_FETCHED_MUNICIPALITY = (municipality) => { return { type: STORE_FETCHED_MUNICIPALITY, payload: municipality } };
export const ACTION_FETCHING_MUNICIPALITY_COMPLETED = () => { return { type: FETCHING_MUNICIPALITY_COMPLETED } };

export const ACTION_SET_MUNICIPALITY_PAGE = (page) => { return { type: SET_MUNICIPALITY_PAGE, payload: page } };
export const ACTION_REMOVE_MUNICIPALITY = () => { return { type: REMOVE_MUNICIPALITY } };
export const ACTION_SET_MUNICIPALITY_FILTERS = (filters) => { return { type: SET_MUNICIPALITY_FILTERS, payload: filters } }
export const ACTION_CLEAR_MUNICIPALITY_REDUCER = () => { return { type: CLEAR_MUNICIPALITY_REDUCER } }

export const ACTION_FETCHING_ALL_MUNICIPALITIES_IN_PROGRESS = () => { return { type: FETCHING_ALL_MUNICIPALITIES_IN_PROGRESS } };
export const ACTION_STORE_FETCHED_ALL_MUNICIPALITIES = (municipalities) => { return { type: STORE_FETCHED_ALL_MUNICIPALITIES, payload: municipalities } };
export const ACTION_FETCHING_ALL_MUNICIPALITIES_COMPLETED = () => { return { type: FETCHING_ALL_MUNICIPALITIES_COMPLETED } };

export const ACTION_EDITING_MUNICIPALITY_IN_PROGRESS = () => { return { type: EDITING_MUNICIPALITY_IN_PROGRESS } };
export const ACTION_EDITING_MUNICIPALITY_COMPLETED = () => { return { type: EDITING_MUNICIPALITY_COMPLETED } };

export const ACTION_FETCHING_MUNICIPALITY_OPTIONS_IN_PROGRESS = () => { return { type: FETCHING_MUNICIPALITY_OPTIONS_IN_PROGRESS } };
export const ACTION_STORE_MUNICIPALITY_OPTIONS = (options) => { return { type: STORE_MUNICIPALITY_OPTIONS, payload: options } };
export const ACTION_FETCHING_MUNICIPALITY_OPTIONS_COMPLETED = () => { return { type: FETCHING_MUNICIPALITY_OPTIONS_COMPLETED } };

export const ACTION_CREATING_MUNICIPALITY_IN_PROGRESS = () => { return { type: CREATING_MUNICIPALITY_IN_PROGRESS } };
export const ACTION_CREATING_MUNICIPALITY_COMPLETED = () => { return { type: CREATING_MUNICIPALITY_COMPLETED } };

export const ACTION_DELETING_MUNICIPALITY_IN_PROGRESS = () => { return { type: DELETING_MUNICIPALITY_IN_PROGRESS } };
export const ACTION_DELETING_MUNICIPALITY_COMPLETED = () => { return { type: DELETING_MUNICIPALITY_COMPLETED } };